// extracted by mini-css-extract-plugin
module.exports = {"dashboardContainer":"AdminDashboard_dashboardContainer__2vR_B"};